import { axiosRef } from '../../../api';

export const addFuelSurcharge = (payload: any) =>
  axiosRef.post(`/fuel_surcharge`, payload);

export const editFuelSurcharge = (payload: any) =>
  axiosRef.put(`/fuel_surcharge/${payload.id}`, payload);

export const fetchFuelSurchargeList = (payload?: any) => {
  let url = `/fuel_surcharge?`;
  if (payload && payload?.pageSize) {
    url =
      url +
      `page_size=${payload.pageSize}&page=${payload.page}&is_pagination=true&`;
  }
  if (payload && payload.code) {
    url = url + `code=${payload.code}&`;
  }
  if (payload && payload.fuel_type) {
    url = url + `fuel_type=${payload.fuel_type}&`;
  }
  return axiosRef.get(url);
};

export { default as getData } from './getData';
export { default as editData } from './editData';
